/* ==========================================================================
   <part-finder> — Yedek Parça Bulucu
   Marka → Ürün Grubu → Seri → Model seçimini Shopify native filtre URL'ine
   çevirip yönlendirir. Backend yok. Veri: assets/finder-data.json
   ========================================================================== */
(function () {
  'use strict';

  class PartFinder extends HTMLElement {
    constructor() {
      super();
      this.brandWrap = this.querySelector('[data-finder-brands]');
      this.groupSel = this.querySelector('[data-finder-group]');
      this.seriesSel = this.querySelector('[data-finder-series]');
      this.modelSel = this.querySelector('[data-finder-model]');
      this.countEl = this.querySelector('[data-finder-count]');
      this.submitBtn = this.querySelector('[data-finder-submit]');
      this.note = this.querySelector('[data-finder-note]');
      this.data = null;
      this.brand = ''; // seçili marka handle
    }

    connectedCallback() {
      const url = this.getAttribute('data-src');
      fetch(url)
        .then((r) => r.json())
        .then((d) => { this.data = d; this.initBrands(); })
        .catch(() => { if (this.note) this.note.textContent = 'Veri yüklenemedi.'; });

      this.groupSel && this.groupSel.addEventListener('change', () => this.onGroup());
      this.seriesSel && this.seriesSel.addEventListener('change', () => this.onSeries());
      this.modelSel && this.modelSel.addEventListener('change', () => this.refreshCount());
      this.submitBtn && this.submitBtn.addEventListener('click', (e) => { e.preventDefault(); this.go(); });
    }

    fill(sel, items, placeholder) {
      if (!sel) return;
      sel.innerHTML = '';
      const ph = document.createElement('option');
      ph.value = ''; ph.textContent = placeholder; sel.appendChild(ph);
      (items || []).forEach((it) => {
        const o = document.createElement('option');
        o.value = it.value;
        // Seçenek yanında parça adedi: "Sigma (240)"
        o.textContent = (it.count || it.count === 0) ? it.label + ' (' + it.count + ')' : it.label;
        sel.appendChild(o);
      });
      sel.disabled = !(items && items.length);
    }

    reset(sel, placeholder) {
      if (!sel) return;
      sel.innerHTML = '<option value="">' + placeholder + '</option>';
      sel.disabled = true;
    }

    // Marka kartlarını (logo/pill) render et
    initBrands() {
      if (!this.brandWrap) return;
      // Logo dosyaları tema asset'lerinde; data-src'den asset taban URL'ini türet
      // (asset_url sonuna ?v=hash ekler; "finder-data.json" ve sonrasını temizle)
      this.assetBase = (this.getAttribute('data-src') || '').replace(/finder-data\.json.*$/, '');
      this.assetVer = ((this.getAttribute('data-src') || '').split('?')[1]) || ''; // ?v=hash → cache-bust
      this.brandWrap.innerHTML = '';
      this.data.brands.forEach((b) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'finder-brand';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', 'false');
        btn.dataset.brand = b.handle;
        btn.title = b.label;
        if (b.logo) {
          const img = document.createElement('img');
          var logoSrc = b.logo.indexOf('//') > -1 ? b.logo : this.assetBase + b.logo;
          img.src = this.assetVer ? logoSrc + '?' + this.assetVer : logoSrc;
          img.alt = b.label; img.loading = 'lazy';
          img.className = 'finder-brand__logo';
          btn.appendChild(img);
        } else {
          const span = document.createElement('span');
          span.className = 'finder-brand__name';
          span.textContent = b.label;
          btn.appendChild(span);
        }
        btn.addEventListener('click', () => this.selectBrand(b.handle, btn));
        this.brandWrap.appendChild(btn);
      });
      this.reset(this.groupSel, this.groupSel.dataset.placeholder);
      this.reset(this.seriesSel, this.seriesSel.dataset.placeholder);
      this.reset(this.modelSel, this.modelSel.dataset.placeholder);
    }

    selectBrand(handle, btn) {
      this.brand = handle;
      this.brandWrap.querySelectorAll('.finder-brand').forEach((el) => {
        const on = el === btn;
        el.classList.toggle('is-selected', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      this.onBrand();
      this.refreshCount();
    }

    currentBrand() { return this.data.brands.find((b) => b.handle === this.brand); }

    // Etkin sayı: düğümün kendi count'u yoksa alt seviyelerin toplamından türet
    sum(arr, fn) { return (arr || []).reduce((a, x) => a + (fn(x) || 0), 0); }
    modelCount(m) { return m.count || 0; }
    seriesCount(s) { return s.count != null ? s.count : this.sum(s.models, (m) => this.modelCount(m)); }
    groupCount(g) { return g.count != null ? g.count : this.sum(g.series, (s) => this.seriesCount(s)); }
    brandCount(b) { return b.count != null ? b.count : this.sum(b.groups, (g) => this.groupCount(g)); }

    // Seçimin en derin seviyesindeki ürün sayısı
    currentCount() {
      const b = this.currentBrand();
      if (!b) return null;
      const g = this.currentGroup();
      if (!g) return this.brandCount(b);
      const s = this.currentSeries();
      if (!s) return this.groupCount(g);
      const m = s.models && s.models.find((x) => x.value === this.modelSel.value);
      if (!m) return this.seriesCount(s);
      return this.modelCount(m);
    }

    refreshCount() {
      if (!this.countEl) return;
      const n = this.currentCount();
      const suffix = this.countEl.dataset.suffix || '';
      this.countEl.textContent = (n || n === 0) ? '· ' + n + ' ' + suffix : '';
    }

    onBrand() {
      if (this.note) this.note.textContent = '';
      this.reset(this.seriesSel, this.seriesSel.dataset.placeholder);
      this.reset(this.modelSel, this.modelSel.dataset.placeholder);
      const b = this.currentBrand();
      if (!b) { this.reset(this.groupSel, this.groupSel.dataset.placeholder); return; }
      if (!b.groups || !b.groups.length) {
        this.reset(this.groupSel, this.groupSel.dataset.placeholder);
        if (this.note) {
          var bc = this.brandCount(b);
          var msg = (bc && bc > 0)
            ? (this.note.dataset.allParts || 'Tüm parçaları görüntüleyin.')
            : (this.note.dataset.noData || 'Bu marka için model verisi yakında.');
          this.note.innerHTML = msg +
            ' <a href="/collections/' + b.collection + '">' + (this.note.dataset.viewBrand || 'Markayı görüntüle') + '</a>';
        }
        return;
      }
      this.fill(this.groupSel, b.groups.map((g) => ({ value: g.value, label: g.label, count: this.groupCount(g) })), this.groupSel.dataset.placeholder);
    }

    currentGroup() { const b = this.currentBrand(); return b && b.groups.find((g) => g.value === this.groupSel.value); }

    onGroup() {
      this.reset(this.modelSel, this.modelSel.dataset.placeholder);
      const g = this.currentGroup();
      this.fill(this.seriesSel, g ? g.series.map((s) => ({ value: s.value, label: s.label, count: this.seriesCount(s) })) : [], this.seriesSel.dataset.placeholder);
      this.refreshCount();
    }

    currentSeries() { const g = this.currentGroup(); return g && g.series.find((s) => s.value === this.seriesSel.value); }

    onSeries() {
      const s = this.currentSeries();
      this.fill(this.modelSel, s ? s.models.map((m) => ({ value: m.value, label: m.label, count: this.modelCount(m) })) : [], this.modelSel.dataset.placeholder);
      this.refreshCount();
    }

    handleize(s) {
      return String(s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }

    go() {
      const b = this.currentBrand();
      if (!b) {
        const first = this.brandWrap && this.brandWrap.querySelector('.finder-brand');
        if (first) first.focus();
        return;
      }
      // Marka koleksiyonu + önekli tag yolu ile native filtreleme (S&D gerektirmez)
      const tags = [];
      if (this.groupSel.value) tags.push('tur-' + this.handleize(this.groupSel.value));
      if (this.seriesSel.value) tags.push('seri-' + this.handleize(this.seriesSel.value));
      if (this.modelSel.value) tags.push('model-' + this.handleize(this.modelSel.value));
      let url = '/collections/' + b.collection;
      if (tags.length) url += '/' + tags.join('+');
      window.location.assign(url);
    }
  }

  if (!customElements.get('part-finder')) customElements.define('part-finder', PartFinder);

  // Finder sekmeleri (görsel)
  document.querySelectorAll('.finder-card__tabs').forEach((tabs) => {
    tabs.querySelectorAll('[data-finder-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.querySelectorAll('[data-finder-tab]').forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  });
})();

